module.exports = __webpack_public_path__ + "media/images/icons/youtube_footer-97b25607c674e8096e767e0b88f49671.svg";